import SpecialtiesHero from "../../Specialties/SpecialtiesHero/SpecialtiesHero";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { useAppContext } from "../../../context/AppState/AppContext";

export default function MissionSection() {
   const { jsonTexts, jsonMedia } = useAppContext();
   const { description, title } = jsonTexts.aboutUs.missionSection;
   const { width } = useWindowDimensions();
   const isMobile = width <= 768;

   const image = jsonMedia?.institutional?.missionBannerImage

   return (
      <SpecialtiesHero
         title={title}
         height={isMobile ? 200 : 250}
         imageUrl={image}
         description={description}
         left={isMobile ? "unset" : "10px"}
         imageBackgroundColor="var(--color-tertiary)"
         square
      />
   );
}
